unit Reports.Summary.Utils;

interface

type
  TSummaryReportUtils = class
  public
    [async]
    class procedure SummaryReport(aGroupByField: string; aStartDate, aEndDate: TDate; aDateField: string); async;
  end;

implementation

uses
  XData.Web.Client,
  MainDataModule,
  JS,
  Reports.Result.Utils;

{ TSummaryReportUtils }

class procedure TSummaryReportUtils.SummaryReport(aGroupByField: string; aStartDate, aEndDate: TDate; aDateField: string);
var
  lRetval: TXDataClientResponse;
begin
  lRetval := Await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('ISummaryReportsService.SummaryReport',
    [aGroupByField, aStartDate, aEndDate, aDateField]));

  TReportResultUtils.HandleReportResult(TJSObject(lRetval.Result));
end;

end.
